import login from './login'
import passenger from './passenger'
import account12306 from './account12306'
import order from './order'
import calendar from './calendar'
import selectStation from './selectStation'
import invoice from './invoice'
import wechat from './wechat'
import userAddress from './userAddress'
import school from './school'
import miniProgramQrCode from './miniProgramQrCode'
import coupons from './coupons'


export default {
  login,
  passenger,
  account12306,
  order,
  calendar,
  selectStation,
  invoice,
  wechat,
  userAddress,
  school,
  miniProgramQrCode,
  coupons
}



// WEBPACK FOOTER //
// ./src/api/index.js